import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeContractForm from './ChangeContractForm'

const ChangeContractButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={supplyBillItem.contract ? supplyBillItem.contract.name : ''}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування контракту/проекту'}
            disableClickOutside={true}
            content={
                <ChangeContractForm
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeContractButton